import React from 'react';
import { checkTextTranslation } from '../../utils/useful';

class PasswordInput extends React.Component {
    state = {
        showPass: false,
        inputValue: ''
    };

    togglePasswordVisibility = () => {
        this.setState(prevState => ({
            showPass: !prevState.showPass
        }));
    };

    changeInputValue = (event) => {
        const { validity, value } = event.target;
        const inputValue = validity.valid ? value : '';

        this.setState({
            inputValue
        });

        this.props.changeValue(this.props.header.key, inputValue, this.props.extra);
    };

    render() {
        let { showPass, inputValue } = this.state;
        let inputType = showPass ? 'text' : 'password';

        return (
            <div className="w-100 h-100 flexcb">
                <input
                    ref={el => (this.input = el)}
                    type={inputType}
                    autoFocus={this.props.header.information.autoFocus}
                    value={inputValue}
                    onChange={this.changeInputValue}
                    placeholder={checkTextTranslation(this.props.header.information.placeholder)}
                    className="transpanet-input"
                />
                <button className='flexcc' onClick={this.togglePasswordVisibility}>
                    {showPass ? (
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.8" stroke="gray" style={{ width: 22 }}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z" />
                            <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                        </svg>
                    ) : (
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.8" stroke="gray" style={{ width: 22 }}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88" />
                        </svg>
                    )}
                </button>
            </div>
        );
    }
}

export default PasswordInput;